import { DIGITAL_LIT_SA_COURSE_ID } from "./CourseResources";

export class DigLitSAConstants
{
  static readonly DIG_LIT_SA_COURSE_ID: number = DIGITAL_LIT_SA_COURSE_ID[0];
  static readonly DIG_LIT_SA_COURSE_NAME: string = "Digital Literacy Self-Assessment";
  
  static readonly DIG_LIT_SA_SLIDER_NOT_AT_ALL: string = $localize`:@@slider-not-at-all:Not at all`;
  static readonly DIG_LIT_SA_SLIDER_SLIGHTLY_CONFIDENT: string = $localize`:@@slider-slightly-confident:Slightly confident`;
  static readonly DIG_LIT_SA_SLIDER_FAIRLY_CONFIDENT: string = $localize`:@@slider-fairly-confident:Fairly confident`;
  static readonly DIG_LIT_SA_SLIDER_QUITE_CONFIDENT: string = $localize`:@@slider-quite-confident:Quite confident`;
  static readonly DIG_LIT_SA_SLIDER_CONFIDENT: string = $localize`:@@slider-confident:Confident`;
  static readonly DIG_LIT_SA_SLIDER_VERY_CONFIDENT: string = $localize`:@@slider-very-confident:Very confident`;

  static readonly DIG_LIT_SA_SLIDER_AUDIO_NOT_AT_ALL_M: string = $localize`:@@dig-lit-sa-not-at-all-male:/repos/scorm/diglit-sa/audio/en/sl_op_1_en_ma.mp3`;
  static readonly DIG_LIT_SA_SLIDER_AUDIO_SLIGHTLY_CONFIDENT_M: string = $localize`:@@dig-lit-sa-slightly-confident-male:/repos/scorm/diglit-sa/audio/en/sl_op_2_en_ma.mp3`;
  static readonly DIG_LIT_SA_SLIDER_AUDIO_FAIRLY_CONFIDENT_M: string = $localize`:@@dig-lit-sa-fairly-confident-male:/repos/scorm/diglit-sa/audio/en/sl_op_3_en_ma.mp3`;
  static readonly DIG_LIT_SA_SLIDER_AUDIO_QUITE_CONFIDENT_M: string = $localize`:@@dig-lit-sa-quite-confident-male:/repos/scorm/diglit-sa/audio/en/sl_op_4_en_ma.mp3`;
  static readonly DIG_LIT_SA_SLIDER_AUDIO_CONFIDENT_M: string = $localize`:@@dig-lit-sa-confident-male:/repos/scorm/diglit-sa/audio/en/sl_op_5_en_ma.mp3`;
  static readonly DIG_LIT_SA_SLIDER_AUDIO_VERY_CONFIDENT_M: string = $localize`:@@dig-lit-sa-very-confident-male:/repos/scorm/diglit-sa/audio/en/sl_op_6_en_ma.mp3`;

  static readonly DIG_LIT_SA_SLIDER_AUDIO_NOT_AT_ALL_F: string = $localize`:@@dig-lit-sa-not-at-all-female:/repos/scorm/diglit-sa/audio/en/sl_op_1_en_fe.mp3`;
  static readonly DIG_LIT_SA_SLIDER_AUDIO_SLIGHTLY_CONFIDENT_F: string = $localize`:@@dig-lit-sa-slightly-confident-female:/repos/scorm/diglit-sa/audio/en/sl_op_2_en_fe.mp3`;
  static readonly DIG_LIT_SA_SLIDER_AUDIO_FAIRLY_CONFIDENT_F: string = $localize`:@@dig-lit-sa-fairly-confident-female:/repos/scorm/diglit-sa/audio/en/sl_op_3_en_fe.mp3`;
  static readonly DIG_LIT_SA_SLIDER_AUDIO_QUITE_CONFIDENT_F: string = $localize`:@@dig-lit-sa-quite-confident-female:/repos/scorm/diglit-sa/audio/en/sl_op_4_en_fe.mp3`;
  static readonly DIG_LIT_SA_SLIDER_AUDIO_CONFIDENT_F: string = $localize`:@@dig-lit-sa-confident-female:/repos/scorm/diglit-sa/audio/en/sl_op_5_en_fe.mp3`;
  static readonly DIG_LIT_SA_SLIDER_AUDIO_VERY_CONFIDENT_F: string = $localize`:@@dig-lit-sa-very-confident-female:/repos/scorm/diglit-sa/audio/en/sl_op_6_en_fe.mp3`;
  static readonly DIG_LIT_SA_AUDIO_WELCOME: string = $localize`:@@dig-lit-sa-welcome:/repos/scorm/diglit-sa/audio/en/welcome_en.mp3`;

  static readonly MUTE_AUDIO: string = $localize`:@@dig-lit-sa-mute-audio:Mute audio`;
  static readonly UNMUTE_AUDIO: string = $localize`:@@dig-lit-sa-unmute-audio:Unmute audio`;
  static readonly PLAY_AUDIO: string = $localize`:@@dig-lit-sa-play-audio:Play audio`;
  static readonly PAUSE_AUDIO: string = $localize`:@@dig-lit-sa-pause-audio:Pause audio`;
  static readonly REPLAY_AUDIO: string = $localize`:@@dig-lit-sa-replay-audio:Replay audio`;
}

export enum QuestionModes {
  Multiple = "multiple",
  Slider = "slider"
}

export enum DigLitQuestionCategories {
  DigitalResponsibility = "Digital Responsibility",
  DigitalProductivity = "Digital Productivity",
  InformationLiteracy = "Information Literacy",
	DigitalCollaboration = "Digital Collaboration",
	DigitalCreativity = "Digital Creativity"
}

export enum DigLitQAndATableHeaders {
  answer = 'answer',
  result = 'result',
}

export enum Voice {
  male = "male",
  female = "female"
}

export const SliderAudioPathsMale = {
  1: DigLitSAConstants.DIG_LIT_SA_SLIDER_AUDIO_NOT_AT_ALL_M,
  2: DigLitSAConstants.DIG_LIT_SA_SLIDER_AUDIO_SLIGHTLY_CONFIDENT_M,
  3: DigLitSAConstants.DIG_LIT_SA_SLIDER_AUDIO_FAIRLY_CONFIDENT_M,
  4: DigLitSAConstants.DIG_LIT_SA_SLIDER_AUDIO_QUITE_CONFIDENT_M,
  5: DigLitSAConstants.DIG_LIT_SA_SLIDER_AUDIO_CONFIDENT_M,
  6: DigLitSAConstants.DIG_LIT_SA_SLIDER_AUDIO_VERY_CONFIDENT_M
}

export const SliderAudioPathsFemale = {
  1: DigLitSAConstants.DIG_LIT_SA_SLIDER_AUDIO_NOT_AT_ALL_F,
  2: DigLitSAConstants.DIG_LIT_SA_SLIDER_AUDIO_SLIGHTLY_CONFIDENT_F,
  3: DigLitSAConstants.DIG_LIT_SA_SLIDER_AUDIO_FAIRLY_CONFIDENT_F,
  4: DigLitSAConstants.DIG_LIT_SA_SLIDER_AUDIO_QUITE_CONFIDENT_F,
  5: DigLitSAConstants.DIG_LIT_SA_SLIDER_AUDIO_CONFIDENT_F,
  6: DigLitSAConstants.DIG_LIT_SA_SLIDER_AUDIO_VERY_CONFIDENT_F
}

export const getSliderAudio = function(key: number, voice: Voice){
  return voice == Voice.female ? 
    SliderAudioPathsFemale[key] : SliderAudioPathsMale[key];
};

export function generateGUID(): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}